export const formatAccounting = (
  value: number | null | undefined,
  currency: string = 'CAD'
): string => {
  const num = value ?? 0;

  // Format absolute value
  const formatted = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(Math.abs(num));

  // Accounting style → negatives in parentheses
  if (num < 0) {
    return `(${formatted})`;
  }

  // Add + sign for positives
  return ` ${formatted}`;
};

export const formatCompactNumber = (
  value: number | null | undefined
): string => {
  const num = Number(value ?? 0);
  if (!Number.isFinite(num)) return '0';

  if (Math.abs(num) < 1000) {
    return Math.round(num).toString();
  }

  return new Intl.NumberFormat('en-CA', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(num);
};
